import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/emr-ethnics";

export const getAllEthnics = () => axios.get(API_PATH + "/get-all-ethnic");

export const pagingEthnics = searchEthnics => axios.post(API_PATH + "/search-by-page", searchEthnics);

export const getEthnicsById = ethnicsId => axios.get(API_PATH + "/getbyid/" + ethnicsId);

export const saveEthnics = ethnics => axios.post(API_PATH + '/save', ethnics);

export const deleteEthnics = ethnicsId => axios.delete(API_PATH + "/mark-delete/" + ethnicsId);